import Vue from 'vue'
import App from './App.vue'
import router from './router'
import MetaInfo from 'vue-meta-info'
import './plugins/element.js'
import echarts from 'echarts'
import china from 'echarts/map/json/china.json'
echarts.registerMap('china',china)
//导入通用样式
import '../src/assets/css/public.css'
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

import axios from 'axios'

Vue.use(MetaInfo)

Vue.prototype.$http = axios

new Vue({
  router,
  render: h => h(App),
  //添加到这里,这里的render-event和vue.config.js里面的renderAfterDocumentEvent配置名称一致
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')

router.afterEach(() => {
  window.scrollTo(0,0);
})
